// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"75ee99db","667":"e71a0b55","977":"056150a2"}[chunkId] + ".chunk.js";
};